export enum CategoryFormStep {
  GENERAL = 'general',
  LATEX = 'latex',
  MODEL = 'model',
  ONLINE_MODEL = 'onlineModel',
  ONLINE_LATEX = 'onlineLatex',
  COUNTRIES = 'countries',
}
